// Formats a Date as YYYY-MM-DD from local components (avoids the UTC shift
// toISOString() would introduce).
export function formatDate(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

export const todayString = (): string => formatDate(new Date());
